import React, { useEffect } from 'react'
import Navigator from '../../../components/common/Navigator'
import MaterialDownloadIcon from '../../../components/common/icons/MaterialDownload'
import { useTenders } from '../api'

const Tenders = () => {
  const { data, isLoading, isError } = useTenders()
  const tenders = data?.data ?? []

  useEffect(() => {
    if (!tenders.length) return
  }, [tenders])

  if (isLoading) {
    return (
      <section className="py-12 px-4">
        <p>Loading tenders...</p>
      </section>
    )
  }

  if (isError) {
    return (
      <section className="py-12 px-4">
        <p>Error loading materials</p>
      </section>
    )
  }
  const handleDownload = (fileUrl: string, fileName: string) => {
    const url = fileUrl.replace(/\\/g, '')

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  console.log(tenders)
  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 my-8">
      <Navigator title="Tenders" slug="TENDERS" />
      <div>
        <h2 className="text-3xl font-bold mb-1">Tenders</h2>
        <p className="text-sm text-gray-900 mb-4">List of current tenders</p>
        <div className="border-t border-primaryBlue mb-8" />
        <div className="overflow-x-auto rounded-md border border-gray-200">
          <table className="min-w-full text-sm text-left">
            <thead>
              <tr className="bg-rose-100 text-gray-800">
                <th className="px-6 py-3 text-lg font-semibold">Data</th>
                <th className="px-6 py-3 font-semibold text-center">
                  File Access
                </th>
              </tr>
            </thead>
            <tbody>
              {tenders.map((item: any, index: any) => (
                <tr
                  key={index}
                  className="border-t border-gray-200 hover:bg-gray-50 transition"
                >
                  {/* <td className="px-6 py-4">{item?.description}</td> */}
                  <td className="px-6 py-4">
                    {item?.description
                      ? item.description.charAt(0).toUpperCase() +
                        item.description.slice(1)
                      : ''}
                  </td>

                  <td className="px-6 py-4 text-center">
                    <button
                      className="inline-flex items-center gap-2 bg-rose-50 hover:bg-rose-100 text-sm text-gray-800 px-4 py-2 rounded-full transition"
                      onClick={() =>
                        handleDownload(item.file, item.description)
                      }
                    >
                      <MaterialDownloadIcon />
                      Download
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default Tenders
